/**
 * Created by JasonChou on 17/6/19.
 */
import React, {Component} from 'react'
import Vertical from '../layouts/Vertical'
import InfiniteScroll from '../InfiniteScroll'
import LoadMore from './LoadMore'

export default class ListScreen extends Component {
    constructor(props) {
        super(...arguments);

        this.state = {
            isRefreshing: true,
            list: [],
            hasMore: false,
            isMoreLoading: false,
            loadMoreParams: {}
        };

        setTimeout(this._onRefresh, 10)
    }

    _getDataByApi(params) {
        return [];
    }

    _onRefresh = async () => {
        this.setState({isRefreshing: true});

        const res = await this._getDataByApi();

        if (res.isOk) {
            const list = res.data.data;
            this.setState({
                isRefreshing: false, list, hasMore: res.data.hasMore,
                loadMoreParams: this._getLoadMoreParam(list)
            })
        } else {
            this.setState({isRefreshing: false})
        }
    };

    _renderOther() {

    }

    _onLoadMore = async () => {
        if (!this.state.hasMore || this.state.isMoreLoading)
            return;

        this.setState({isMoreLoading: true});
        let res = await this._getDataByApi(this.state.loadMoreParams, false);

        if (res.isOk) {
            const list = this.state.list.concat(res.data.data);
            this.setState({
                isMoreLoading: false,
                list,
                hasMore: res.data.hasMore,
                loadMoreParams: this._getLoadMoreParam(list)
            });
        } else
            this.setState({isMoreLoading: false});
    };

    render() {
        return (
            <InfiniteScroll style={styles.root_container} onLoadMore={this._onLoadMore}>
                {this._renderHeader && this._renderHeader()}
                {this.state.list.map((item, index) => {
                    return this._renderItem({item, index})
                })}

                {this._renderOther()}

                <LoadMore hasMore={this.state.hasMore} loading={this.state.isMoreLoading}/>
            </InfiniteScroll>)
    }

    _renderItem = ({item, index}) => {

    };

    _getLoadMoreParam = (list) => {
        return {}
    }
}


const styles = {
    root_container: {
        height: '100%'
    }
};


// WEBPACK FOOTER //
// ./src/components/list_screen/ListScreen.js